import React from "react";

/**
 * InfoCard
 * Props:
 *  - icon: bootstrap-icons class string, e.g. "bi-people-fill"
 *  - title: string
 *  - text: string
 */
function InfoCard({ icon, title, text }) {
  return (
    <div className="card apk-card p-4 h-100">
      <div className="icon-circle mb-3">
        <i className={`bi ${icon}`}></i>
      </div>
      <h5 className="fw-bold text-navy mb-2">{title}</h5>
      <p className="text-secondary mb-0">{text}</p>
    </div>
  );
}

export default InfoCard;
